import styled from "@emotion/styled";
import { CircularProgress } from "@mui/material";

import useCookieSessionManager from "@rf-hooks/useCookieSessionManager";

import HamtersLoadder from "./hamter-loadder";

interface ILoaders {
  type?: "hamster" | "spinner";
}
function Loaders(props: ILoaders) {
  const { data } = useCookieSessionManager();

  if (data) {
    const User = data ?? "";
    const userTest = User.email == "alan@version.do";
    const { type = userTest ? "hamster" : "spinner" } = props;
    return (
      <ContentProgress>
        {type === "hamster" && <HamtersLoadder />}
        {type === "spinner" && <CircularProgress />}
      </ContentProgress>
    );
  } else {
    return (
      <ContentProgress>
        <CircularProgress />
      </ContentProgress>
    );
  }
}

export default Loaders;

const ContentProgress = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  align-items: center;
  height: calc(100vh - 92px);
  flex-direction: column;
`;
